import React from "react";
import { Stack, Typography, Card, Divider } from "@mui/material";
import { useNavigate } from "react-router-dom";
import Header from "../../core/Header/Header";
import ButtonMain from "../../components/Button";
import "./style.css";

const AccountDeletion = () => {
  const navigate = useNavigate();

  return (
    <Stack
      alignItems="center"
      justifyContent="center"
      sx={{
        width: "100%",
        minHeight: "100vh",
        backgroundColor: "#f5f5f5",
        padding: 2,
      }}
    >
      <Header />

      <Card
        sx={{
          width: { xs: "100%", sm: 420 },
          padding: 4,
          borderRadius: 3,
          boxShadow: 3,
        }}
      >
        <Typography variant="h5" fontWeight={700} gutterBottom>
          Account Deletion Policy
        </Typography>

        <Typography variant="body2" color="text.secondary" mb={2}>
          App Name: <strong>Alkauser Admissions</strong>
          <br />
          Developer: <strong>Alkauser Admissions</strong>
        </Typography>

        <Divider sx={{ my: 2 }} />

        <Typography variant="subtitle1" fontWeight={600} gutterBottom>
          How to Request Account Deletion
        </Typography>

        <Typography variant="body2" mb={2}>
          To delete your account, please send an email from your registered email
          address to:
        </Typography>

        <Typography variant="body2" mb={1}>
          <strong>Email:</strong> contact@alkauser.net
        </Typography>
        <Typography variant="body2" mb={2}>
          <strong>Subject:</strong> Account Deletion Request
        </Typography>

        <Typography variant="body2" mb={2}>
          Your request will be processed within <strong>7 working days</strong>.
        </Typography>

        <Divider sx={{ my: 2 }} />

        <Typography variant="subtitle1" fontWeight={600} gutterBottom>
          Data That Will Be Deleted
        </Typography>

        <Typography variant="body2" component="ul" sx={{ pl: 2 }}>
          <li>User profile information</li>
          <li>Email address</li>
          <li>Login credentials</li>
          <li>Application records</li>
          <li>Uploaded documents</li>
        </Typography>

        <Divider sx={{ my: 2 }} />

        <Typography variant="subtitle1" fontWeight={600} gutterBottom>
          Data Retention
        </Typography>

        <Typography variant="body2" mb={2}>
          Some data may be retained temporarily for legal or regulatory purposes
          and will be permanently deleted within <strong>30 days</strong>.
        </Typography>

        <ButtonMain
          variant="white"
          fullWidth
          sx={{ mt: 2 }}
          onClick={() => navigate("/")}
        >
          Back to Login
        </ButtonMain>
      </Card>
    </Stack>
  );
};

export default AccountDeletion;
